import { css } from '@emotion/css';
import {
  ColorsWhite,
  ColorsPrimary200,
  Spacings3,
  Spacings4,
} from '@efexteam/design-tokens';

const container = css({
  minHeight: '100vh',
  backgroundColor: ColorsWhite,
});

const header = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: Spacings3,
});

const logoContainer = css({
  maxWidth: '150px',
  marginLeft: Spacings4,
  marginTop: '8px',
});

const headerActions = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const mainGrid = css({
  height: 'calc(100vh - 100px)',
});

const formSection = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: Spacings4,
});

const imageSection = css({
  display: 'none',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: ColorsPrimary200,
  '@media (min-width: 768px)': {
    display: 'flex',
  },
});

const backgroundImage = css({
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
  borderRadius: '0',
});

const AuthLayoutStyles = {
  container,
  header,
  logoContainer,
  headerActions,
  mainGrid,
  formSection,
  imageSection,
  backgroundImage,
};

export default AuthLayoutStyles;
